export const clientAr = {
  "Dette": "دَين",
  "Creance": "مدين",
  "Nom...": "الاسم...",
  "Telephone...": "الهاتف...",
  "Chercher un Client": "ابحث عن زبون",
  "Choisir un client": "اختر الزبون",
  "Information du client": "معلومات العميل",

  "Historique de paiements": "تاريخ المدفوعات",

}